import axios from 'axios';
import { API_UPLOAD_URL } from "../config";
import type { IResponse } from "../types/api";

type UploadResponse = [
    {
        url: string;
    }
];

const MAX_UPLOAD_SIZE = 4_194_304; // 4.8MB in bytes

export const uploadFile = (file: File, directory?: string, prefix?: string): Promise<string | undefined> => {
    const uploadDir = directory ?? 'uploads';
    return new Promise(async (resolve, reject) => {
        const contentType = file.type || "multipart/form-data";
        try {
            if (file.size >= MAX_UPLOAD_SIZE) {
                const data = {
                    contentType: file?.type,
                    fileName: file?.name,
                    useFileName: true
                }
                const res = await axios({
                    method: "post",
                    url: `${API_UPLOAD_URL}/signed/v1/${directory ?? 'image'}`,
                    data,
                });
                const uploadUrl = res?.data?.result?.uploadUrl ?? '';
                const url = res?.data?.result?.url ?? '';

                const uploadResponse = await axios({
                    url: uploadUrl,
                    method: 'put',
                    headers: {
                        'Content-Type': file.type
                    },
                    noAuthorization: true,
                    data: file,
                });

                if (uploadResponse.status === 200) {
                    resolve(url ?? undefined);
                }
                reject()
            } else {
                const formData = new FormData();
                formData.append('file', file);
                const { data } = await axios<IResponse<UploadResponse>>({
                    method: 'post',
                    url: `${API_UPLOAD_URL}/upload/v1/${uploadDir}?prefix=${prefix ?? uploadDir}`,
                    data: formData,
                    headers: {
                        'Content-Type': contentType
                    }
                })
                resolve(data?.result?.[0]?.url ?? undefined)
            }
        } catch (e) {
            if (e instanceof Error) {
                console.log('File Upload Error: ', e.message);
                reject()
            }
        }
    })
}